import { jsxs, jsx } from "react/jsx-runtime";
const IconBulletListSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M6 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm13 3h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2Zm0 8h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2Z" })
    ]
  }
);
export {
  IconBulletListSvg
};
